var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("brick-octagon-base", {
    staticClass: "journey-brick",
    class: _vm.classList,
    nativeOn: {
      click: function($event) {
        return _vm.handleClick($event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content-top",
        fn: function() {
          return [
            _vm.hasUnseenComments
              ? _c("has-unseen-comments-marker", {
                  staticClass: "has-unseen-comments-marker"
                })
              : _vm._e(),
            _vm._v(" "),
            _c("journey-brick-menu", {
              staticClass: "brick-dropdown-menu",
              attrs: { "brick-id": _vm.id }
            })
          ]
        },
        proxy: true
      },
      {
        key: "icon",
        fn: function() {
          return [_c(_vm.iconSvg, { tag: "component" })]
        },
        proxy: true
      },
      {
        key: "content-bottom",
        fn: function() {
          return [
            _vm.showSettings
              ? _c(_vm.editorType, {
                  tag: "component",
                  attrs: { brick: _vm.brick, show: _vm.showSettings },
                  on: {
                    hidden: function($event) {
                      return _vm.onSettingsHidden()
                    },
                    save: function($event) {
                      return _vm.onSave($event)
                    },
                    delete: function($event) {
                      return _vm.onDelete()
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }